import type { RouteRecordRaw } from 'vue-router';

export const settingRoutes: Array<RouteRecordRaw> = [
  {
    path: '/setting',
    name: 'setting',
    redirect: '/setting/list',
    component: () => import('pages/central/setting/AppSetting.vue'),
    meta: {
      title: 'Application Settings',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'settingList',
        component: () => import('pages/central/setting/AppSettingList.vue'),
        meta: {
          title: 'Application Settings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'settingDetail',
        component: () => import('pages/central/setting/AppSettingDetail.vue'),
        meta: {
          title: 'Application Setting Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'settingNew',
        component: () => import('pages/central/setting/AppSettingNew.vue'),
        meta: {
          title: 'New Application Setting',
          requiresAuth: true,
        },
      },
    ],
  },
];
